import React, { useEffect } from 'react';
import Analytics from 'react-ga';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import intl from 'react-intl-universal';
import AppInfo from './AppInfo';
import ContactForm from '../ContactForm';
import SignUpStepper from '../SignUpStepper';
import { redirectToShoppingCart } from '../../../utils/navigation';

const useStyles = makeStyles(() => ({
  rootContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 50rem)': {
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: 0
    }
  },
  leftContainer: {
    maxWidth: '28rem'
  },
  rightContainer: {
    maxWidth: '28rem'
  },
  box: {
    boxShadow: '0 12px 12px -3px #ccc'
  },
  stepper: {
    padding: 0
  },
  step: {
    display: 'none'
  }
}));

export default function PaidSignUpSection() {
  const classes = useStyles();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const plan = queryParams.get('plan');
  useEffect(() => {
    Analytics.event({
      action: 'initiate checkout',
      category: 'ecom',
      label: `${plan}`
    });
  }, [plan]);
  const onSignUpSuccess = async (email: string, password: string) => {
    await redirectToShoppingCart(plan, email, password);
  };
  return (
    <section>
      <Box className={classes.rootContainer} mt={4}>
        <Box className={classes.leftContainer} mx={4} my={2}>
          <AppInfo />
        </Box>
        <Box className={classes.rightContainer} mx={4} my={2}>
          <SignUpStepper step={1} totalSteps={1} />
          <Box className={classes.box} p={4}>
            <ContactForm
              onSignUpSuccess={onSignUpSuccess}
              buttonText={intl.get('components.ContactForm.continueToCheckout')}
            />
          </Box>
        </Box>
      </Box>
    </section>
  );
}
